import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { routes } from '@app/consts/routes';
import { TranslateService } from '@ngx-translate/core';
import { FeatureService } from '@app/core/services/feature.service';
import { ModuleConfigurationService } from '@app/core/services/module-configuration/module-configuration.service';
import { SiteSettingsService } from '../site-settings-page/services/site-settings.service';

@Component({
    selector: 'app-site-settings-menu',
    templateUrl: './site-settings-menu.component.html',
    styleUrls: ['./site-settings-menu.component.scss']
})
export class SiteSettingsMenuComponent implements OnInit {
    public routes: typeof routes = routes;
    navList = [];

    constructor(
        public translate: TranslateService,
        public router: Router,
        private featureService: FeatureService,
        private moduleConfigurationService: ModuleConfigurationService,
        private siteSettingsService: SiteSettingsService
    ) {
        this.navList = this.siteSettingsService.menuItems;
    }

    ngOnInit(): void {
        this.removeFeaturesWithoutModuleAccess();
        this.navigateToFirstAllowedSection();
    }

    // If the client doesnt have access to a module remove it form the list
    removeFeaturesWithoutModuleAccess() {
        this.navList = this.navList.filter(
            feature => {
                if(feature.module) {
                    return this.moduleConfigurationService.hasModuleAccess(feature.module);
                }
                else {
                    return true;
                }
            }
        )
    }

    navigateToFirstAllowedSection() {
        let urlToNavigateTo = '';

        if(this.router.url === `${routes.SITE_SETTINGS}`) {
          this.navList.every(element => {
            let hasAccess = this.featureService.hasFeatureAccess(element.featureCode)

            if(hasAccess){
              urlToNavigateTo = element.link;
              return false;
            }

            return true;
          });
        }

        if(urlToNavigateTo !== ''){
          this.router.navigate([urlToNavigateTo]);
        }
    }
}
